import { useReleases } from 'components/Analytics/Filters/hooks/useReleases';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const navigate = useNavigate();
  const { releases, fetching } = useReleases();
  const [searchTerm, setSearchTerm] = useState('');

  const releasesData = releases?.map(({ id, title }) => ({ id, title })) || [];

  const filteredReleases = releasesData.filter(
    ({ id, title }) =>
      title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      id.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <Input
          placeholder="Find by release title or code"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Content>
          {fetching ? (
            <Loading>
              <ProgressSpinner />
            </Loading>
          ) : filteredReleases.length > 0 ? (
            filteredReleases.map(({ id, title }) => (
              <TextBox key={id} onClick={() => navigate(`/smart-link-creation/${id}/new`)}>
                <div>{title}</div>
                <span>{id}</span>
              </TextBox>
            ))
          ) : (
            <Empty>No results found</Empty>
          )}
        </Content>
      </ModalContainer>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  background: #fff;
  border-radius: 10px;
  width: 364px;
  height: 304px;
  overflow-y: auto;
  padding: 20px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 16px;
  font-size: 14px;
  outline:none;
  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const TextBox = styled.div`
  padding: 10px 12px;
  background: #f9f9f9;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #eef3ff;
  }

  div {
    font-weight: 500;
  }

  span {
    font-size: 12px;
    color: #888;
  }
`;

const Loading = styled.div`
  text-align: center;
  color: #555;
`;

const Empty = styled.div`
  text-align: center;
  color: #999;
`;

